import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
export var Colors = {
    AZUL_GOV: "#034EA2",
    AMARELO_GOV: "#FDB913",
    VERMELHO_GOV: "#EF4123",
    VERDE_GOV: "#007932",
};
export var GLOBAL_CHART_COLOR_PALETTE = [
    "#034EA2",
    "#FDB913",
    "#EF4123",
    "#10B981",
    "#8B5CF6",
    "#1F77B4",
    "#FF7F0E",
    "#2CA02C",
    "#EC4899",
    "#0EA5E9",
    "#D62728",
    "#6366F1",
    "#BCBD22",
    "#8C564B",
    "#17BECF",
    "#F59E0B",
    "#9467BD",
    "#FFD700",
    "#007932",
    "#E377C2",
    "#7F7F7F",
    "#084081",
    "#FFBB78",
    "#005A32",
    "#FF9896",
    "#3F007D",
    "#C49C94",
    "#9EDAE5",
    "#666600",
    "#4A90E2",
    "#DBDB8D",
    "#A63603",
    "#C5B0D5",
    "#016C59",
    "#AEC7E8",
    "#98DF8A",
    "#F7B6D2",
    "#FCE68D",
    "#7F0000",
    "#54270F",
    "#88419D",
    "#252525",
    "#C7C7C7",
    "#B8860B",
];
export var getCategoricalChartColor = function (_label, index) {
    return GLOBAL_CHART_COLOR_PALETTE[index % GLOBAL_CHART_COLOR_PALETTE.length];
};
export var buildCategoricalColorPalette = function (count, _labels) {
    if (_labels === void 0) { _labels = []; }
    return Array.from({ length: count }, function (_, index) {
        return getCategoricalChartColor("CATEGORY_".concat(index), index);
    });
};
export var theme = createTheme({
    palette: {
        primary: {
            main: Colors.AZUL_GOV,
        },
        secondary: {
            main: "#19857b",
        },
        error: {
            main: red.A400,
        },
    },
    typography: {
        fontFamily: [
            "Montserrat",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                // Name of the slot
                root: {
                    borderRadius: "14px",
                    background: "#FFFFFF",
                    borderWidth: 1,
                    borderColor: "#ECEEF4",
                    boxShadow: "none",
                },
            },
        },
    },
});
